var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVirtualQueue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:none;stroke:#006DF0;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:#006DF0;}\n\t.st4{fill:none;stroke:#37CE93;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#37CE93;stroke-width:3;stroke-miterlimit:10;stroke-dasharray:27,4;}\n\t.st6{fill:none;stroke:#37CE93;stroke-width:3;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#006DF0;stroke-width:3;stroke-miterlimit:10;}\n\t.st8{fill:#37CE93;}\n\t.st9{fill:none;stroke:#37CE93;stroke-width:3;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 50,
    cy: 93,
    rx: 15,
    ry: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 70,
    cy: 81,
    rx: 15,
    ry: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 30,
    cy: 81,
    rx: 15,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.67,
    y: 59.16,
    className: "st1",
    width: 52.65,
    height: 19.84
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.4,
    y: 67.16,
    className: "st1",
    width: 19.21,
    height: 19.84
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.41,
    y: 83.26,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 138.4148 38.4148)",
    className: "st1",
    width: 7.17,
    height: 10.31
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1595 -0.9872 0.9872 0.1595 9.2398 77.2754)",
    className: "st6",
    cx: 50,
    cy: 33.21,
    rx: 12.87,
    ry: 12.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M41.94,17.86c-1.3-5.73-6.41-10.3-12.53-10.3c-7.11,0-12.88,5.76-12.88,12.87c0,3.28,1.26,6.23,3.28,8.5 c-5.23,4.31-7.6,9.84-8.43,19.82c0,4.33,0,9.18,5.58,10.13l2.22,11.09c1.47,5.88,5.48,9.68,10.22,9.68c1.87,0,3.62-0.61,5.15-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M65.45,77.97c1.53,1.09,3.28,1.7,5.15,1.7c4.74,0,8.75-3.8,10.25-9.79l2.19-10.97 c5.58-0.95,5.58-5.82,5.57-10.35c-0.81-9.77-3.18-15.3-8.42-19.61c2.01-2.27,3.27-5.23,3.27-8.5c0-7.11-5.76-12.87-12.87-12.87 c-6.13,0-11.23,4.57-12.53,10.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M40.41,41.72c-5.24,4.31-7.6,9.85-8.43,19.82c0,4.33,0,9.18,5.58,10.14l2.22,11.09 c1.47,5.88,5.48,9.68,10.22,9.68h0c4.74,0,8.76-3.8,10.25-9.79l2.19-10.97c5.58-0.95,5.58-5.83,5.57-10.35 c-0.81-9.77-3.18-15.3-8.42-19.61"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M53.88,45.43L53.88,45.43L53.88,45.43z M53.88,45.43c0,0-2.09,0.89-4.39,0.89c-1.15,0-2.34-0.22-3.36-0.89 l2.15,3.23l-3.43,8.58L50,64.11l5.15-6.87l-3.43-8.58L53.88,45.43L53.88,45.43z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualQueue);
export default __webpack_public_path__ + "static/media/Virtual_Queue.649adbceceb95d0a9b15ef142d56f69b.svg";
export { ForwardRef as ReactComponent };